import React from 'react'
import { connect } from 'react-redux'
import { makeStyles, MenuItem, Typography } from '@material-ui/core'
import { getFlagAssetForLanguageId } from '../../Logic/FlagUnicodeLogic'
import Select from '@material-ui/core/Select'

const useStyles = makeStyles((theme) => ({
    select: {
        width: '180px',
        height: '40px',
        backgroundColor: 'white',
        borderRadius: theme.shape.borderRadius,
    },

    menuItemContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'left',
        gap: '8px',
    },
    flagImageContainer: {
        height: '30px',
        justifyItems: 'center',
        alignItems: 'center',
    },
    localizationNameContainer: {
        height: '30px',
        justifyItems: 'center',
    },
    localizationNameText: {
        width: '120px',
        textAlign: 'left',
        marginLeft: '1px',
        paddingTop: '3px',
    },
}))

const LocalizationSelector = ({ localizationLanguages, dashboardLanguageId, onChangeLocalizedLanguage }) => {
    const classes = useStyles()

    return (
        <Select
            value={dashboardLanguageId ? dashboardLanguageId : 1}
            className={classes.select}
            onChange={onChangeLocalizedLanguage}>
            {localizationLanguages?.map((language) => {
                return (
                    <MenuItem value={language.id} key={language.id}>
                        <div style={{}} className={classes.menuItemContainer}>
                            <div className={classes.flagImageContainer}>
                                <div style={{ marginLeft: '5px' }}>
                                    <img width="30" src={getFlagAssetForLanguageId(language.id)}></img>
                                </div>
                            </div>
                            <div className={classes.localizationNameContainer}>
                                <Typography className={classes.localizationNameText}>
                                    {language.nativeFriendlyName}
                                </Typography>
                            </div>
                        </div>
                    </MenuItem>
                )
            })}
        </Select>
    )
}

LocalizationSelector.propTypes = {}

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(LocalizationSelector)
